import {Gallery} from './Gallery'
(function(){
    const $galleryListing = document.querySelectorAll('.gallery')
    if($galleryListing.length) $galleryListing.forEach($gl => new Gallery.GalleryListing($gl))
    
})()